export type ThemeMode = 'light' | 'dark' | 'auto';

export type EffectiveTheme = 'light' | 'dark';

export interface ThemePreferences {
  themeMode: ThemeMode;
  version: number;
  updatedAt?: string;
}

export const DEFAULT_THEME_PREFERENCES: ThemePreferences = {
  themeMode: 'light',
  version: 1,
};
